import * as React from "react"
import {
  Button,
  Textarea,
  Heading,
  Box,
  VStack,
  Text,
  Flex,
  FormControl,
  FormLabel,
} from "@chakra-ui/react"
import { RxMagicWand } from "react-icons/rx"
import {
  companyDescriptionLabel,
  companyDescriptionPlaceholder,
  projectDescriptionPlaceholder,
  demoText2,
  demoText3,
  demoTitle,
  generateButtonText,
  projectDescriptionLabel,
} from "../constants/texts"

const CharCounter = ({
  current,
  maxLength,
  isMaxLength,
}: {
  current: number
  maxLength: number
  isMaxLength: boolean
}) => {
  return (
    <Text
      fontSize="smaller"
      textColor={isMaxLength ? "red.500" : "dmazegray.900"}
      textAlign={"right"}
    >{`${current}/${maxLength}`}</Text>
  )
}

export const AIDemoForm = ({
  maxNumberOfTries,
  setShowResults,
  showResults,
  setProjectDescription,
  setCompanyDescription,
  projectDescription,
  companyDescription,
}: {
  maxNumberOfTries: number
  setShowResults: (showResults: boolean) => void
  showResults: boolean
  setProjectDescription: (projectDescription: string) => void
  setCompanyDescription: (companyDescription: string) => void
  projectDescription: string
  companyDescription: string
}) => {
  const maxCompanyDescriptionLength = 200
  const maxProjectDescriptionLength = 800
  const [tooLongCompanyDescription, setTooLongCompanyDescription] =
    React.useState<boolean>(false)
  const [tooLongProjectDescription, setTooLongProjectDescription] =
    React.useState<boolean>(false)

  const handleProjectDescriptionChange = (
    e: React.ChangeEvent<HTMLTextAreaElement>
  ) => {
    if (e.target.value.length > maxProjectDescriptionLength) {
      setTooLongProjectDescription(true)
      setProjectDescription(
        e.target.value.substring(0, maxProjectDescriptionLength)
      )
    } else {
      setTooLongProjectDescription(false)
      setProjectDescription(e.target.value)
    }
  }
  const handleCompanyDescriptionChange = (
    e: React.ChangeEvent<HTMLTextAreaElement>
  ) => {
    if (e.target.value.length > maxCompanyDescriptionLength) {
      setTooLongCompanyDescription(true)
      setCompanyDescription(
        e.target.value.substring(0, maxCompanyDescriptionLength)
      )
      setTimeout(() => {
        setTooLongCompanyDescription(false)
      }, 150)
    } else {
      setTooLongCompanyDescription(false)
      setCompanyDescription(e.target.value)
    }
  }

  return (
    <VStack spacing={"20px"} marginTop="4px" w="100%">
      <Box marginBottom="12px">
        <Heading as="h1">{demoTitle}</Heading>
        <Text>{demoText2}</Text>
        <Text>{demoText3}</Text>
      </Box>
      <Box width="100%">
        <FormControl>
          <FormLabel fontWeight={600} paddingBottom="8px">
            {companyDescriptionLabel}
          </FormLabel>
          <Textarea
            h="80px"
            placeholder={companyDescriptionPlaceholder}
            value={companyDescription}
            onChange={handleCompanyDescriptionChange}
            isInvalid={tooLongCompanyDescription}
            maxLength={maxCompanyDescriptionLength + 1}
            className={tooLongCompanyDescription ? "toolong" : ""}
          />
          <CharCounter
            isMaxLength={tooLongCompanyDescription}
            current={companyDescription.length}
            maxLength={maxCompanyDescriptionLength}
          />
        </FormControl>
      </Box>
      <Box width="100%">
        <FormControl>
          <FormLabel fontWeight={600} paddingBottom="8px">
            {projectDescriptionLabel}
          </FormLabel>
          <Textarea
            placeholder={projectDescriptionPlaceholder}
            value={projectDescription}
            onChange={handleProjectDescriptionChange}
            maxLength={maxProjectDescriptionLength + 1}
            className={tooLongProjectDescription ? "toolong" : ""}
          />
          <CharCounter
            isMaxLength={tooLongProjectDescription}
            current={projectDescription.length}
            maxLength={maxProjectDescriptionLength}
          />
        </FormControl>
      </Box>
      <Flex direction="column" align="center">
        <Button
          marginBottom="24px"
          leftIcon={<RxMagicWand />}
          type="submit"
          onClick={() => setShowResults(!showResults)}
          cursor={
            projectDescription === "" || companyDescription === ""
              ? "not-allowed"
              : "pointer"
          }
        >
          {generateButtonText}
        </Button>
        <Text color="dmazegray.900" as="i">
          Try {maxNumberOfTries} times for free
        </Text>
      </Flex>
    </VStack>
  )
}
